<template>
	<div id="app">
		
		<!--mobile-->
		<div class="h-100" v-if="isMobile">
			<div class="rotate-device justify-content-center">
				<div class="align-self-center p-4 text-left">
					<p>
						Pentru a vizualiza conținutul aplicației mai în detaliu
						te rugăm să întorci dispozitivul în modul portrait.
					</p>
				</div>
				<div class="align-self-center p-4">
					<img alt="" src="@/assets/rotate-device.png">
				</div>
			</div>

			<router-view v-if="!showAgeGate" />

			<!--age gate-->
			<div v-show="showAgeGate && !minorAgeGate" class="container-age-gate">
				<figure class="mb-5">
                    <img class="img-fluid" alt="Iqos Pocket" src="@/assets/logo.png" />
                </figure>
				<h1 class="title title--sm text-uppercase mb-5">
					Acest website este destinat persoanelor cu vârsta peste 18 ani, fumătoare și rezidente în România. Dorești să continui?
				</h1>
				<div class="mb-5">
					<button @click="minorAgeGate = true" class="btn btn--primary mx-4 py-3 px-5" type="button">NU</button>
					<button @click="setAgeGate" class="btn btn--primary mx-4 py-3 px-5" type="button">DA</button>
				</div>
				<p class="mb-3">
					Centrul de Asistență Clienți – LiveChat pe IQOS Club; zilnic, în intervalul 8:00 – 22:00. Copyright 2015 - 2019 Philip Morris Trading S.R.L. Toate drepturile rezervate.
				</p>
				<p>
					Bine ai venit pe CLUB.IQOS.ro, un website operat de Philip Morris Trading S.R.L. Aici vei putea afla mai multe despre elementele și caracteristicile produsului IQOS și, de asemenea, vei putea cumpăra sistemul IQOS, componente ale sistemului IQOS și HEETS, pentru a fi utilizate exclusiv cu IQOS. Noi tratăm foarte atent modul în care publicul larg află despre produsele noastre și, de asemenea, modul în care acesta le achiziționează. Poți accesa acest site numai dacă ai peste 18 ani, ești fumător și rezident în România. Pentru a confirma faptul că ești fumător și ai vârsta de peste 18 ani, te rugăm să folosești butonul „DA”. În caz contrar, te rugăm să folosești butonul „NU”. În continuare, în interiorul site-ului, îţi pot fi solicitate informații suplimentare cu caracter personal, în vederea achiziționării IQOS, a produselor IQOS sau HEETS.
				</p>
			</div>
			<!--end age gate-->

			<!--age gate - not 18-->
			<div v-show="minorAgeGate" class="container-age-gate">
				<figure class="mb-5">
                    <img class="img-fluid" alt="Iqos Pocket" src="@/assets/logo.png" />
                </figure>
				<h2 class="title title--sm text-uppercase mb-5">
					Trebuie să ai peste 18 ani pentru a accesa acest website.
				</h2>
				<button @click="minorAgeGate = false" class="btn btn--primary mx-4 py-3 px-5" type="button">OK</button>
			</div>
			<!--end age gate - not 18-->

			<!--install app ios-->
			<div v-if="isIOS">
				<div v-show="addApp" class="ios-bar-install">
					<div class="w-100 ios-bar-install__left">
						<button @click="howAddApp = true" class="btn btn--add-app btn--arrow text-uppercase" type="button">
							<span>
								Adaugă IQOS Pocket pe Home Screen
								<i class="icon icon--arrow-right icon--abs-rc"></i>
							</span>
						</button>
					</div>
					<div>
						<button @click="closeAddApp" class="btn btn--close-app" type="button">
							<i class="icon icon--close"></i>
						</button>
					</div>
				</div>
				<div v-show="howAddApp" class="ios-how-install">
					<div class="ios-how-install__inner">
						<button @click="howAddApp = false" class="btn btn--close-how-install p-4" type="button">
							<i class="icon icon--close"></i>
						</button>
						<h2>Urmează pașii de mai jos:</h2>
						<p>
							1. Apasă butonul de <span>share <img class="icons-ios" alt="" src="@/assets/icon-ios-share.png"></span> din banda de jos a browser-ului tău Safari.
							<br><br>
							2. Scrollează până găsești butonul <span>Add to Home Screen <img alt="" src="@/assets/icon-ios-add.png"></span>
						</p>
					</div>
				</div>
			</div>
			<!--end install app ios-->

		</div>
		<!--end mobile-->

		<!--desktop-->
		<div class="h-100" v-else>
			<Desktop />
		</div>
		<!--end desktop-->

	</div>
</template>

<script>

import { isMobile, isIOS } from 'mobile-device-detect';
import Desktop from "@/views/Desktop";

export default {
	name: 'App',
	data () {
		return {
			isMobile : isMobile,
			isIOS: isIOS,
			showAgeGate: true,
			minorAgeGate: false,
			addApp: true,
			howAddApp: false
		}
	},
	components: {
		Desktop
	},

	methods: {
		resize() {
			this.$store.commit('setWindowSize', document.documentElement);
		},
		setAgeGate() {
			this.$cookies.set('iqos-age-verified', 'yes');
			this.showAgeGate = false;
		},
		closeAddApp() {
			this.$cookies.set('iqos-close-add-app', 'yes');
			this.addApp = false;
		}
	},
	beforeMount() {
		this.resize();
	},
	created() {

		//detects if device is in standalone mode
		var isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

		//if cookie "close add app" is set = hide age gate
		//checks if should display install popup notification install app
		if (this.$cookies.isKey('iqos-close-add-app') || (isIOS && isInStandaloneMode())) {
			this.addApp = false;
		}
		
		//if cookie "age gate" is set = hide age gate
		if (this.$cookies.isKey('iqos-age-verified')) {
			this.showAgeGate = false;
		}
		
	},
	mounted() {
		window.addEventListener('resize', this.resize);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.resize);
	}
}

</script>
